




















import { Vue, Component, Prop } from "vue-property-decorator";
import AnxLink from "../AnxLink/AnxLink.vue";
import AnxIcon from "../AnxIcon/AnxIcon.vue";
import AnxParagraph from "../AnxParagraph/AnxParagraph.vue";

/**
 * The *anx-card* is a special layout used on websites of Anexia.
 * It contains an icon, a header, a link and some text.
 */
@Component({
  components: {
    AnxLink,
    AnxIcon,
    AnxParagraph
  }
})
export default class Card extends Vue {
  /** This is the header for the card */
  @Prop() title!: string;

  /** This is the text for the link */
  @Prop({ default: null }) linkText!: string | null;

  /** This is the link for the card */
  @Prop({ default: "#" }) link!: string;

  /**
   * This is the icon of the card.
   * A *anx-icon* component is used to parse the string.
   */
  @Prop({ default: null }) icon!: string | null;

  /**
   * If no icon is provided, an image will be rendered as fallback.
   * The image property shoudl contain a link to the image resource.
   */
  @Prop({ default: null }) image!: string | null;
}
